// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"885e1d78","453":"27a2f1f4","732":"e5072fc0"}[chunkId] + ".chunk.js";
};